/**
 * BND HOLDING - Single Source of Truth for Branding & Design Tokens
 * Signature: « Bâtir. Préserver. Transmettre. »
 */

export const branding = {
  name: "BND HOLDING",
  fullName: "BND HOLDING",
  tagline: "Bâtir. Préserver. Transmettre.",
  subtitle: "Prestige Immobilier, Structuration Patrimoniale & Investissement",
  legalName: "BND HOLDING SARL",
  logo: "/assets/branding/bnd-holding-logo.png",
  logoSvg: "/assets/branding/bnd-holding-logo.svg",
  favicon: "/favicon.ico",
  email: "contact@bndholding.com",
  phone: "+221 33 800 00 00",
  address: "Almadies / Point E, Dakar, Sénégal",
  copyright: `© ${new Date().getFullYear()} BND HOLDING. Tous droits réservés.`,
  socials: {
    facebook: "https://facebook.com",
    instagram: "https://instagram.com",
    linkedin: "https://linkedin.com",
    twitter: "https://twitter.com"
  },
  colors: {
    darkPrimary: "#080808",
    darkSecondary: "#111111",
    goldPremium: "#C9A227",
    goldLight: "#E1C45A",
    offWhite: "#F7F5EF",
    grayLight: "#E5E5E5",
    graySecondary: "#A1A1A1",
    success: "#2E8B57",
    error: "#C94C4C"
  }
};

export default branding;
